module.exports = __webpack_public_path__ + "static/media/arrow-right.cf09d4cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/arrow-right.svg
// module id = 617
// module chunks = 0